// Calculate partial vacation days based on employment start date and vacation contract
export const calculatePartialVacation = (startDate, vacationContract, targetYear) => {
  if (!startDate || !vacationContract || !targetYear) return '';

  const start = new Date(startDate);
  const year = parseInt(targetYear);

  // If start date is not in the target year, return full contract
  if (start.getFullYear() !== year) {
    return start.getFullYear() < year ? vacationContract : 0;
  }

  let monthsWorked = 0;
  const startMonth = start.getMonth(); // 0-based (0 = January)
  const startDay = start.getDate();

  // Count months from employment start to end of year
  for (let month = startMonth; month <= 11; month++) {
    if (month === startMonth) {
      // First month: count if 15+ days worked
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const daysWorked = daysInMonth - startDay + 1;
      if (daysWorked >= 15) {
        monthsWorked++;
      }
    } else {
      // Full months
      monthsWorked++;
    }
  }

  // Calculate partial vacation: (contract / 12) * months, rounded up
  const partialVacation = (vacationContract / 12) * monthsWorked;
  return Math.ceil(partialVacation);
};